import { Component, OnInit, inject } from '@angular/core';
import { EntityTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { IdentityEntityGroup } from 'projects/bis-shared/src/lib/auth/security-models';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { CommonModule } from '@angular/common';
import { HealthcareProviderDashboardComponent } from './healthcare-provider-dashboard/healthcare-provider-dashboard.component';
import { InsurerDashboardComponent } from './insurer-dashboard/insurer-dashboard.component';
import { ThirdPartyAdministratorDashboardComponent } from './third-party-administrator-dashboard/third-party-administrator-dashboard.component';
import { PharmacyBenefitManagerDashboardComponent } from './pharmacy-benefit-manager-dashboard/pharmacy-benefit-manager-dashboard.component';
import { UtilizationReviewerDashboardComponent } from './utilization-reviewer-dashboard/utilization-reviewer-dashboard.component';
import { AuthenticatedNoGroupMembershipComponent } from './authenticated-no-group-membership/authenticated-no-group-membership.component';
import { MedicalSupplierDashboardComponent } from './medical-supplier-dashboard/medical-supplier-dashboard.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    CommonModule,
    HealthcareProviderDashboardComponent,
    InsurerDashboardComponent,
    ThirdPartyAdministratorDashboardComponent,
    PharmacyBenefitManagerDashboardComponent,
    UtilizationReviewerDashboardComponent,
    AuthenticatedNoGroupMembershipComponent,
    MedicalSupplierDashboardComponent,
  ],
})
export class DashboardComponent implements OnInit {
  private identityService = inject(IdentityService);
  private route = inject(ActivatedRoute);

  readonly EntityType = EntityTypeCode;
  belongsToHealthcareProviderGroup: boolean = false;
  entityTypeCode: string;
  myGroups: IdentityEntityGroup[];
  systemUserId: number;
  redirectedToTabIndex: number;

  
 

  

  ngOnInit(): void {
    this.redirectedToTabIndex = +this.route.snapshot.queryParamMap.get('redirectToTab');
    this.myGroups = _.filter(this.identityService.identity.entityGroups, g =>
      _.some(g.userRoleCodes),
    );
    this.systemUserId = this.identityService.identity.userId;
    this.myGroups.forEach((entityGroup: IdentityEntityGroup) => {
      if (!this.belongsToHealthcareProviderGroup) {
        this.entityTypeCode = entityGroup.entityTypeCode;

        if (entityGroup.entityTypeCode === EntityTypeCode.HealthcareProvider) {
          this.belongsToHealthcareProviderGroup = true;
        }
      }
    });
  }
}
